'use strict';

export default function objectTable () {
    let $table = $('.js-object-table');

    if (!$table.length) {
        return;
    }

    $table.find('.has_modules').on('click', function () {
        $(this)
            .closest('tr')
            .toggleClass('active')
            .nextUntil('tr:not(.table_row_invisible)')
            .toggle();
    });
}
